import { RestApiResponse } from '../../common/rest-api.response';

import { Person } from './person';

export class PersonGetResponse extends RestApiResponse {
    public person: Person;

    constructor(data?: Partial<PersonGetResponse>) {
        super(data);
        this.person = new Person(data?.person);
    }
}
